/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.13.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import { WIZARD_STORAGE_CLEAR_STEPS } from '../../modules/wizard/wizardConstants';
import { TWizardExpensesDetailActions } from './types/wizardExpensesDetailActionTypes';
import {
    IWizardExpensesDetailHierarchyLevel,
    IWizardExpensesDetailValidation,
} from './types/wizardExpensesDetailTypes';
import {
    initWizardExpensesDetailState,
    WIZARD_EXPENSES_DETAIL_SET_PARAMS,
    WIZARD_EXPENSES_DETAIL_UPDATE_DATA,
    WIZARD_EXPENSES_DETAIL_VALIDATION,
} from './wizardExpensesDetailConstant';

export interface IWizardExpensesDetailReducer {
    date: string;
    formatsAvailable: string[];
    formatsAvailableChosen: string;
    hierarchyLevels: IWizardExpensesDetailHierarchyLevel[];
    hierarchyLevelsChosen: IWizardExpensesDetailHierarchyLevel;
    maxDate: string;
    validation: IWizardExpensesDetailValidation;
}

const wizardExpensesDetailReducer: Reducer<IWizardExpensesDetailReducer, TWizardExpensesDetailActions> =
    (state = initWizardExpensesDetailState, action: TWizardExpensesDetailActions) =>
        produce(state, draft => {
            switch (action.type) {
                case WIZARD_EXPENSES_DETAIL_SET_PARAMS:
                case WIZARD_EXPENSES_DETAIL_UPDATE_DATA:
                    Object.assign(draft, { ...draft, ...action.payload });
                    break;

                case WIZARD_EXPENSES_DETAIL_VALIDATION:
                    draft.validation = action.payload;
                    break;

                case WIZARD_STORAGE_CLEAR_STEPS:
                    Object.assign(draft, initWizardExpensesDetailState);
                    break;
            }
        });

export default wizardExpensesDetailReducer;
